import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable @typescript-eslint/no-floating-promises */
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { useSetPlaylistThumbnail } from '..';
import { FormattedMessage } from '../../../components/I18n';
import { useLesson } from '../../lessons';
import { ThumbnailItem } from '../../thumbnail';
import { useTrack } from '../../tracks';

const ChangePlaylistThumbnailButton = (_ref) => {
  let {
    playlistId,
    item,
    children,
    onClick,
    use
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["playlistId", "item", "children", "onClick", "use"]);

  const [setPlaylistThumbnail] = useSetPlaylistThumbnail(playlistId);
  const trackId = item && item.type === 'TRACK' && item.itemId;
  const lessonId = item && item.type === 'LESSON' && item.itemId;
  const language = item && item.language;
  const {
    lesson,
    lessonLoading
  } = useLesson(Number(lessonId), language, !lessonId);
  const {
    track,
    trackLoading
  } = useTrack(Number(trackId), language, !trackId);
  const isLoading = lessonLoading || trackLoading;

  const handleOnClick = e => {
    if (lesson || track) {
      if (track) {
        setPlaylistThumbnail(track.previewThumbnailRectangleUrl, track.previewThumbnailSquareUrl);
      } else {
        setPlaylistThumbnail(lesson.previewThumbnailRectangleUrl, lesson.previewThumbnailSquareUrl);
      }
    }

    if (onClick) onClick(e);
  };

  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    disabled: isLoading,
    onClick: handleOnClick,
    use: use || 'unstyled'
  }, props, {
    children: children ? /*#__PURE__*/_jsx(_Fragment, {
      children: children
    }) : item ? /*#__PURE__*/_jsxs(UIFlex, {
      gap: 8,
      style: {
        height: '100%'
      },
      children: [/*#__PURE__*/_jsx(ThumbnailItem, {
        language: language,
        lessonId: lessonId || undefined,
        trackId: trackId || undefined
      }), /*#__PURE__*/_jsx(UITruncateString, {
        children: item.name
      })]
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyNav.cardMenu.changeThumbnail"
    })
  }));
};

export default ChangePlaylistThumbnailButton;